import './lib/magic-link-bootstrap';

// Security: Load the router and telemetry only after login credentials are out of the URL.
void import('./app');
